import React from "react";
import { Modal } from "antd";
import SentimentDocs from "./SentimentDocs";
import { useSelector } from "react-redux";
import SentimentDocsTest from "./SentimentDocsTest";

export const OverallSentimentDetailsModal = ({
                                                 props,
                                                 selectedSentiment,
                                                 setSelectedSentiment,
                                                 topConceptsBySentiment,
                                                 additionalFilter,
                                                 include_sentiment_on_concepts,

                                             }) => {
    const flags = useSelector((state) => state.auth.flags);
    let { sentiment_share_ai } = flags;
    if (!selectedSentiment) return null;
    return (
        <Modal
            title={`Top Concepts for ${selectedSentiment.charAt(0).toUpperCase() + selectedSentiment.slice(1)}`}
            open={!!selectedSentiment}
            onCancel={() => setSelectedSentiment(null)}
            footer={null}
        >
            <ul>
                {topConceptsBySentiment[selectedSentiment].map((concept) => (
                    <li key={concept.name}>
                        {sentiment_share_ai ?
                            <SentimentDocsTest
                                props={props}
                                include_sentiment_on_concepts={include_sentiment_on_concepts}
                                additionalFilter={additionalFilter}
                                concept={concept}
                            /> :
                            <SentimentDocs
                                include_sentiment_on_concepts={include_sentiment_on_concepts}
                                additionalFilter={additionalFilter}
                                concept={concept}
                            />
                        }
                    </li>
                ))}
            </ul>
        </Modal>
    );
};
